const HsCodeViewer = ({ hsCodes = [] }) => {
  if (!hsCodes.length) return null;

  const availableHsCodes = hsCodes.filter(
    (item) => item?.code && item?.description
  );
  return (
    <div>
      {availableHsCodes.map((item, index, arr) => (
        <div key={index}>
          <div className="o-row o-row--gap-size_500 u-padding--bottom_300">
            <p className="u-width--min-width_100 t-bold_bold">{item.code}:</p>
            <p>{item.description?.replaceAll("-", "")}</p>
          </div>

          {/* Divider except the last item */}
          {index !== arr.length - 1 && (
            <div className="c-hs-code-viewer">
              <div></div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default HsCodeViewer;
